// extracted by mini-css-extract-plugin
export var container = "WidgetFormQuote-module--container--9b6c2";
export var quote = "WidgetFormQuote-module--quote--20773";
export var textContainer = "WidgetFormQuote-module--textContainer--43e2d";